module.exports = __webpack_public_path__ + "static/logo-champions.159f84cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-champions.svg
// module id = 583
// module chunks = 71851226274881